import { isFetchCollectionResultSuccessful } from '@/entities/FetchResult'
import { getTransportationOptionsCall } from '@/entities/TransportationOption/TransportationService'
import { TypedDispatch } from '@/redux/store'

import { setError, setIsLoading, setTransportationOptions } from './transportationOptionsReducer'

export const fetchTransportationOptions = () => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsLoading(true))
    dispatch(setError(''))

    try {
        const response = await getTransportationOptionsCall()

        if (! isFetchCollectionResultSuccessful(response)) {
            dispatch(setError(response.error))

            return
        }

        dispatch(setTransportationOptions(response.data))
    } catch (error) {
        console.error('[fetchTransportationOptions]', error)
    } finally {
        dispatch(setIsLoading(false))
    }
}
